export const BASE_URL = 'https://lab.kuaiqucai.com/api/'
